module.exports = __webpack_public_path__ + "static/media/grill-2.4ca4d197.jpg";